
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M308.499 94.173c-50.437 0-91.467 41.03-91.467 91.467 0 8.968 7.269 16.237 16.237 16.237H383.73c8.974 0 16.237-7.269 16.237-16.237-.001-50.436-41.031-91.467-91.468-91.467zm-56.721 75.231c7.068-24.658 29.822-42.757 56.721-42.757s49.652 18.099 56.72 42.757H251.778zM217.032 325.277H132.6c-8.968 0-16.237 7.269-16.237 16.237v154.25h32.474V357.751h51.958v138.013h32.474v-154.25c-.001-8.968-7.269-16.237-16.237-16.237z"}}),_c('path',{attrs:{"d":"M287.391 0h-90.926c-20.891 0-37.886 16.995-37.886 37.886v303.087h32.474V37.886c0-2.933 2.479-5.412 5.412-5.412h90.926c2.933 0 5.412 2.479 5.412 5.412v73.607h32.474V37.886c0-20.891-17-37.886-37.886-37.886zM406.461 479.526H105.539c-8.968 0-16.237 7.269-16.237 16.237 0 8.968 7.269 16.237 16.237 16.237h300.922c8.968 0 16.237-7.269 16.237-16.237 0-8.968-7.269-16.237-16.237-16.237z"}}),_c('path',{attrs:{"d":"M324.736 185.641c0 7.756-6.311 14.072-14.072 14.072h-4.33c-7.761 0-14.072-6.311-14.072-14.072h-32.474c0 25.665 20.88 46.545 46.545 46.545h4.33c25.67 0 46.545-20.881 46.545-46.545h-32.472z"}})])
          )
        }
      }
    